import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LoadingService } from 'axis-components/components/loading/loading.service';
import { ConfigConstants } from 'src/app/model/config-constants';
import { GmdService } from '../../services/gmd.service';

@Component({
  selector: 'app-dashboard-new',
  templateUrl: './dashboard-new.component.html',
  styleUrls: ['./dashboard-new.component.scss']
})
export class DashboardNewComponent implements OnInit {
  public regions;
  public countries;
  public locations;
  public searchResult;
  public states;
  public contacts;
  public selectedRegion;
  public selectedCountry;
  public disableSearch = true;
  public title = '';
  public description = '';
  public searchForm: FormGroup;
  constructor(private router: Router, private gmdService: GmdService, private fb: FormBuilder, public loadingService: LoadingService) { }

  ngOnInit(): void {
    this.loadingService.start();
    sessionStorage.removeItem('selectedRegionId');
    sessionStorage.removeItem('selectedCountryId');
    sessionStorage.removeItem('selectedLocationId');
    this.searchForm = this.fb.group({
      region: '',
      country: ''
    });
    this.gmdService.getRegions().subscribe((obs)=> this.regions = obs);
    this.gmdService.getPublicPageData({app: ConfigConstants.GMD_APP}).subscribe((obs)=> {
      this.title = decodeURI(obs[0].title);
      this.description = decodeURI(obs[0].description);
      this.loadingService.stop();
    })
    setTimeout(() => {
      this.loadingService.stop();
    }, 1300);
  }

  touch(trv) {
    trv.isTouched = true;
  }

  onRegionSelected(selectedRegion) {
    this.countries = [];
    this.selectedCountry = '';
    this.disableSearch = true;
    this.validate();
    if (selectedRegion && selectedRegion !== null) {
      this.selectedRegion = selectedRegion.regionId;
      sessionStorage.setItem('selectedRegionIdLanding', this.selectedRegion);
    this.gmdService.getCountries({ regionId: selectedRegion.regionId }).subscribe((obs)=> this.countries = obs);
    }
  }

  onCountrySelected(selectedCountry) {
    this.disableSearch = true;
    if (selectedCountry && selectedCountry !== null) {
      this.selectedCountry = selectedCountry.countryId;
    }
    sessionStorage.setItem('selectedCountryIdLanding', this.selectedCountry);
  }

  public search(): void {
    this.router.navigateByUrl('/gmd/view-results');
  }
  public clear() {
    this.selectedRegion = '';
    this.selectedCountry = '';
    this.disableSearch = true;
    this.searchForm.reset();
    this.countries = [];
  }
  public validate() {
    if (this.selectedRegion && this.selectedRegion !== '' && this.selectedCountry && this.selectedCountry !== '') {
      this.disableSearch = false;
    } else {
      this.disableSearch = true;
    }
  }

  public downloadCSV() {
    this.gmdService.downloadCSV().subscribe((obs)=> {
      const blob = new Blob([obs], { type: 'text/csv;charset=utf-8' });
      const data = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.download = `Marine Claims Worldwide Directory.csv`;
      a.href = data;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(data);
      a.remove();
    });
  }
  public downloadPDF() {
    this.gmdService.downloadPDF().subscribe((obs)=> {
      const blob = new Blob([obs], { type: 'text/pd;charset=utf-8' });
      const data = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.download = `Marine Claims Worldwide Directory.pdf`;
      a.href = data;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(data);
      a.remove();
    });
  }
}
